// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"blI9QNkk","headerWrapper":"LBfVUqxv","scrollHeader":"I_V70YlV","header":"za9NW_6j","animPaddings":"kmV7HdKV","rightSideContent":"Csn01WU_","hidedScrollImg":"_7K6ZbuG4"};